import { useState } from 'react';
import {
  configuratorUpdateApi,
  apiGetDownloadConfigurator,
  deleteConfiguratorApi,
  deleteMultipleConfiguratorsApi,
  configuratorTemplateUpdateApi,
  configuratorUpdateApiV2,
} from '../api/configuratorApi';
import { MODEL_TYPES } from '../constants/constants';
import { useUserContext } from '../contexts/UserContext';
import { productConfiguratorsSelectors } from '../redux/slicers/productConfiguratorsSlicer';
import { useModelActions } from './useModelActions';
import { download } from '../common/DownloadFileController/downloadFile';
import { errorToast, successToast } from '../helpers/toastHelper';
import { useInfoDialogaActions } from './useInfoDialogaActions';
import { warningToast } from '../helpers/toastHelper';
import { isAdminOrOwner } from '../helpers/userHelper';
import { dispatcher } from '../helpers/projectHelper';
import { productConfiguratorsActions } from '../redux/slicers/productConfiguratorsSlicer';

export const useConfiguratorActions = ({ item, isTemplateCard }) => {
  const { currentUser } = useUserContext();
  const { openInfoDialog } = useInfoDialogaActions();
  const [downloading, setDownloading] = useState(false);
  const [deleteConf, setDeleteConf] = useState(false);
  const { downloadConfigurator, downloadLoading } = useDownloadConfigurator();
  const { deleteConfigurator, deleteLoading } = useDeleteConfigurator();
  const { favouriteLoading, onFavouriteToggle, onShare, addToCollection } = useModelActions({
    item,
    modelType: MODEL_TYPES.CONFIGURATOR,
    selectors: productConfiguratorsSelectors,
    updateApi: isTemplateCard
      ? configuratorTemplateUpdateApi
      : item?.version_type === 'V2'
      ? configuratorUpdateApiV2
      : configuratorUpdateApi,
    deleteConfig: {
      title: `Do you want to delete ${item?.name}?`,
      deleteApi: deleteConfigurator,
    },
  });

  const download = async (id) => {
    setDownloading(true);
    // TODO: implement downloading
    await downloadConfigurator(id);
    setDownloading(false);
  };

  const onDelete = async (id) => {
    // setDeleteConf(true);
    // // TODO: implement downloading
    // await deleteConfigurator(id);
    // setDeleteConf(false);
    setDeleteConf(true);
    const { created_by_details, name } = item;
    if (!isAdminOrOwner(currentUser) && created_by_details.id !== currentUser.id) {
      setDeleteConf(false);
      warningToast('You do not have ownership to delete this item.', {
        toastId: `CAN_NOT_DELETE_${item.id}`,
      });
      return;
    }
    openInfoDialog({
      title: `Do you want to delete ${name || 'this configurator'}?`,
      description: 'Your items can be restored from the Trash area.',
      cancelButtonText: 'No',
      buttonText: 'Yes',
      onButtonClick: async () => {
        await deleteConfigurator(id);
      },
    });
  };
  return {
    onDelete,
    onFavouriteToggle,
    favouriteLoading,
    download,
    downloading,
    onShare,
    addToCollection,
  };
};

export const useDownloadConfigurator = () => {
  const [loading, setLoading] = useState(false);
  const downloadConfigurator = async (idOrList) => {
    if (loading) return;
    setLoading(true);
    await downloadProjectFile(idOrList);
    setLoading(false);
  };
  return { downloadConfigurator, downloadLoading: loading };
};

const downloadProjectFile = async (idOrList) => {
  const formData = new FormData();
  if (Array.isArray(idOrList)) {
    idOrList.forEach((id) => {
      formData.append('id', id);
    });
  } else {
    formData.append('id', idOrList);
  }
  const res = await apiGetDownloadConfigurator(formData);
  if (res.status) {
    res?.data?.zip_file?.map((item) => {
      download({
        fileUrl: item.zip_url,
        fileName: `${item.name}.zip`,
      });
    });
  } else {
    errorToast(res?.message);
  }
};

export const useDeleteConfigurator = () => {
  const [loading, setLoading] = useState(false);

  const deleteConfigurator = async (idOrList) => {
    if (loading) return;
    setLoading(true);
    let res = await deleteConfiguratorFile(idOrList);
    if (res) {
      successToast('Configurator deleted successfully');
      dispatcher(
        productConfiguratorsActions.deleteSuccess({
          itemId: idOrList,
        })
      );
    }
    setLoading(false);
  };

  return { deleteConfigurator, deleteLoading: loading };
};

const deleteConfiguratorFile = async (idOrList) => {
  const formData = new FormData();
  let res;
  if (Array.isArray(idOrList)) {
    idOrList.forEach((id) => {
      formData.append('id', id);
    });
    res = await deleteMultipleConfiguratorsApi(formData);
  } else {
    res = await dispatcher(deleteConfiguratorApi(idOrList));
  }
  return res;
};
